import { createFeatureSelector, createSelector } from '@ngrx/store';
import isEmpty from 'lodash.isempty';
import {
  ABOUT_TAB_FRAGMENT,
  ALL_PRODUCTS_TAB_FRAGMENT,
  CANCELLATION_POLICY_TAB_FRAGMENT,
  DATA_POLICY_TAB_FRAGMENT,
  TAKE_BACK_INFORMATION_TAB_FRAGMENT,
  TERMS_AND_CONDITIONS_TAB_FRAGMENT,
} from '../constants';
import { Seller, Tab } from '../models';
import { SELLER_FEATURE_NAME } from './feature-name';
import { State } from './state';

export const getSellerModuleState = createFeatureSelector(SELLER_FEATURE_NAME);

export const getSellerState = createSelector(getSellerModuleState, (state: State) => state && state.seller);

export const getSellerPayload = createSelector(getSellerState, (state) => state && state.payload);

export const generateTabs = createSelector(getSellerPayload, (seller: Seller): Tab[] => {
  if (isEmpty(seller)) {
    return [];
  }

  let tabs: Tab[] = [
    {
      fragment: ABOUT_TAB_FRAGMENT,
      content: seller,
    },
    {
      fragment: ALL_PRODUCTS_TAB_FRAGMENT,
      content: seller.shopName,
    },
    {
      fragment: TERMS_AND_CONDITIONS_TAB_FRAGMENT,
      content: seller.termsAndConditions,
    },
    {
      fragment: CANCELLATION_POLICY_TAB_FRAGMENT,
      content: seller.cancellationPolicy,
    },
    {
      fragment: DATA_POLICY_TAB_FRAGMENT,
      content: seller.dataPolicy,
    },
  ];

  if (!!seller.takeBackInformation) {
    tabs = [...tabs, { fragment: TAKE_BACK_INFORMATION_TAB_FRAGMENT, content: seller.takeBackInformation }];
  }

  return tabs;
});
